import { actionChannel, call, put, takeEvery } from "redux-saga/effects";

import {
  POST_APP_DYNAMICS_ENABLE_DISABLE_ALERTS,
  POST_APP_DYNAMICS_CREATE_RESOURCE_ALERTS,
  POST_APP_DYNAMICS_CREATE_DYNAMIC_ALERT,
  GET_APP_DYNAMICS_ALERTS,
  GET_APP_DYNAMICS_DYNAMIC_ALERTS,
  GET_APP_DYNAMICS_MISSING_DYNAMIC_ALERTS,
  GET_APP_DYNAMICS_DEFAULT_THRESHOLD,
  GET_APP_DYNAMICS_RESOURCE_BY_ID,
  GET_APP_DYNAMICS_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
  POST_APP_DYNAMICS_ALERT,
  GET_APP_DYNAMICS_MISSING_ALERT_BY_RESOURCE_ID,
  GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_PAGE,
  GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  POST_APP_DYNAMICS_SERVICE_MAPPING,
  POST_APP_DYNAMICS_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_APP_DYNAMICS_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  GET_ALL_ORG_APP_DYNAMICS_RESOURCE_TYPES,
  GET_APP_DYNAMICS_RESOURCES,
  GET_RESCAN_STATUS_APP_DYNAMICS,
  POST_UPDATE_APP_DYNAMICS_THRESHOLD,
  POST_ENABLE_DISABLE_APP_DYNAMICS_THRESHOLD, GET_APP_DYNAMICS_RESCAN,
  GET_AD_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_APP_DYNAMICS_THRESHOLD,
    GET_APP_DYNAMICS_ALL_EXTERNAL_SERVICES,
    GET_APP_DYNAMICS_ALL_BUSINESS_TRANSACTIONS,
    POST_MARK_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
    GET_AD_NON_KEY_TRANSACTIONS
} from "./actionTypes";

import { 
  postAppDynamicsEnableDisableAlertsSuccess,
  postAppDynamicsEnableDisableAlertsFail,
  postAppDynamicsCreateResourceAlertsSuccess,
  postAppDynamicsCreateResourceAlertsFail,
  postAppDynamicsCreateDynamicAlertSuccess,
  postAppDynamicsCreateDynamicAlertFail,
  getAppDynamicsAlertsFail,
  getAppDynamicsAlertsSuccess,
  getAppDynamicsDynamicAlertsFail,
  getAppDynamicsDynamicAlertsSuccess,
  getAppDynamicsMissingDynamicAlertsFail,
  getAppDynamicsMissingDynamicAlertsSuccess,
  getAppDynamicsDefaultThresholdFail,
  getAppDynamicsDefaultThresholdSuccess,
  getAppDynamicsResourceByIdFail,
  getAppDynamicsResourceByIdSuccess,
  getAppDynamicsResourcesDefaultThresholdByIdFail,
  getAppDynamicsResourcesDefaultThresholdByIdSuccess,
  postAppDynamicsAlertFail,
  postAppDynamicsAlertsSuccess,
  getAppDynamicsRescanFail,
  getAppDynamicsRescanSuccess,
  getAppDynamicsMissingAlertByResourceIdFail,
  getAppDynamicsMissingAlertsByResourceIdSuccess,
  getAppDynamicsAllResourceAlertsPageFail,
  getAppDynamicsAllResourceAlertsPageSuccess,
  getAppDynamicsAllResourceAlertsCountPageFail,
  getAppDynamicsAllResourceAlertsCountPageSuccess,
  postAppDynamicsServiceMappingFail,
  postAppDynamicsServiceMappingSuccess,
  postAppDynamicsResourceOpsGenieTeamMappingFail,
  postAppDynamicsResourceOpsGenieTeamMappingSuccess,
  postAppDynamicsResourcePagerdutyMappingFail,
  postAppDynamicsResourcePagerdutyMappingSuccess,
  getAppDynamicsResourcesFail,
  getAppDynamicsResourcesSuccess,
  getAllOrgAppDynamicsResourceTypesFail,
  getAllOrgAppDynamicsResourceTypesSuccess,
  getRescanStatusAppDynamicsFail,
  getRescanStatusAppDynamicsSuccess,
  postUpdateAppDynamicsThresholdFail,
  postUpdateAppDynamicsThresholdSuccess,
  postEnableDisableAppDynamicsThresholdFail,
  postEnableDisableAppDynamicsThresholdSuccess,
  getMissingADAlertsByResourceIDFail, 
  getMissingADAlertsByResourceIDSuccess,
  getAppDynamicsThresholdFail,
  getAppDynamicsThresholdSuccess,
    getAppDynamicsAllExternalServicesPageSuccess,
    getAppDynamicsAllExternalServicesPageFail,
    getAppDynamicsAllBusinessTransactionsSuccess,
    getAppDynamicsAllBusinessTransactionsFail,
    getADNonKeyTransactionsFail,
    getADNonKeyTransactionsSuccess,
    postMarkNonKeyTransactionAsBusinessTransactionFail,
    postMarkNonKeyTransactionAsBusinessTransactionSuccess
 } from "./actions";

 import {
  postAppDynamicsEnableDisableAlertsUrl,
  postAppDynamicsCreateResourceAlertsUrl,
  postAppDynamicsCreateDynamicAlertUrl,
  getAppDynamicsAlertUrl,
  getAppDynamicsDynamicAlertsUrl,
  getAppDynamicsMissingDynamicAlertsUrl,
  getAppDynamicsDefaultThresholdUrl,
  getAppDynamicsResourceByIdUrl,
  getAppDynamicsResourceDefaultThresholdByIdUrl,
  postAppDynamicsAlertUrl,
  getAppDynamicsRescanUrl,
  getAppDynamicsMissingAlertByResourceIdUrl,
  getAppDynamicsAllResourceAlertsPageUrl,
  getAppDynamicsAllResourceAlertsCountPageUrl,
  getAppDynamicsAllBusinessTransactionAlertsUrl,
  getAppDynamicsAllExternalServicesURL,
  postAppDynamicsServiceMappingUrl,
  postAppDynamicsResourceOpsgenieTeamMappingUrl,
  postAppDynamicsResourcePagerdutyServiceMappingUrl,
  getAppDynamicsResourcesUrl,
  getAllOrgAppDynamicsResourceTypesUrl,
  getRescanStatusAppDynamicsUrl,
  postUpdateAppDynamicsThresholdUrl,
  postEnableDisableAppDynamicsThresholdUrl, 
  getAppDynamicsResourceByIDUrl,
  getAppDynamicsThresholdUrl,
  getNonKeyTransactionsByParentResourceUrl,
  postMarkNonKeyTransactionAsBusinessTransactionUrl
 } from "helpers/fakebackend_helper";


  function* onPostEnableDisableAppDynamicsThreshold({payload:data}) {
    try{
      const response = yield call(postEnableDisableAppDynamicsThresholdUrl, data) 
      yield put(postEnableDisableAppDynamicsThresholdSuccess(response));
    } catch(error) {
      yield put(postEnableDisableAppDynamicsThresholdFail(error));
    }
  }

  function* onPostUpdateAppDynamicsThreshold({payload:data}) {
    try{
      const response = yield call(postUpdateAppDynamicsThresholdUrl, data)
      yield put(postUpdateAppDynamicsThresholdSuccess(response))
    } catch(error) {
      yield put(postUpdateAppDynamicsThresholdFail(error))
    }
  }

  function* onGetRescanStatusAppDynamics() {
    try{
      const response = yield call(getRescanStatusAppDynamicsUrl)
      yield put(getRescanStatusAppDynamicsSuccess(response))
    } catch(error) {
      yield put(getRescanStatusAppDynamicsFail(error))
    }
  } 

  function* onGetAllOrgAppDynamicsResourceTypes() {
    try{
      const response = yield call(getAllOrgAppDynamicsResourceTypesUrl)
      yield put(getAllOrgAppDynamicsResourceTypesSuccess(response))
    } catch(error) {
      yield put(getAllOrgAppDynamicsResourceTypesFail(error))
    }
  }

  function* onGetAppDynamicsResources() {
    try{
      const response = yield call(getAppDynamicsResourcesUrl)
      yield put(getAppDynamicsResourcesSuccess(response))
    } catch(error) {
      yield put(getAppDynamicsResourcesFail(error))
    }
  }

  function* onPostAppDynamicsServiceMapping(data) {
    try{
      const response = yield call(postAppDynamicsServiceMappingUrl, data.payload)
      yield put(postAppDynamicsServiceMappingSuccess(response))
      window.location.reload()
    } catch(error) {
      yield put(postAppDynamicsServiceMappingFail(error))
    }
  }

  function* onPostAppDynamicsResourceOpsgenieTeamMapping(data) {
    try{
      const response = yield call(postAppDynamicsResourceOpsgenieTeamMappingUrl, data.payload)
      yield put(postAppDynamicsResourceOpsGenieTeamMappingSuccess(response));
      window.location.reload()
    } catch(error) {
      yield put(postAppDynamicsResourceOpsGenieTeamMappingFail(error))
    }
  }

  function* onPostAppDynamicsResourcePagerdutyServiceMapping(data) {
    try{
      const response = yield call(postAppDynamicsResourcePagerdutyServiceMappingUrl, data.payload) 
      yield put(postAppDynamicsResourcePagerdutyMappingSuccess(response));
      window.location.reload()
    } catch(error) {
      yield put(postAppDynamicsResourcePagerdutyMappingFail(error))
    }
  }

  function* onGetAppDynamicsAllResourceAlertsPage({payload:data}) {
    try{
      const response = yield call(getAppDynamicsAllResourceAlertsPageUrl, data);
      yield put(getAppDynamicsAllResourceAlertsPageSuccess(response));
    } catch(error) {
      yield put(getAppDynamicsAllResourceAlertsPageFail(error))
    }
  }

  function* onGetAppDynamicsAllResourceAlertsCountPage({payload:data}) {
    try{
      const response = yield call(getAppDynamicsAllResourceAlertsCountPageUrl, data)
      yield put(getAppDynamicsAllResourceAlertsCountPageSuccess(response));
    } catch(error) {
      yield put(getAppDynamicsAllResourceAlertsCountPageFail(error))
    }
  }

  function* onGetAppDynamicsMissingAlertByResourceId(monitored_resource_id) {
    try{
      const response = yield call(getAppDynamicsMissingAlertByResourceIdUrl, monitored_resource_id)
      yield put(getAppDynamicsMissingAlertsByResourceIdSuccess(response))
    } catch(error) {
      yield put(getAppDynamicsMissingAlertByResourceIdFail(error))
    } 
  }
  
  function* onGetAppDynamicsRescan() {
    try{
      const response = yield call(getAppDynamicsRescanUrl);
      yield put(getAppDynamicsRescanSuccess(response))
    } catch(error) {
      yield put(getAppDynamicsRescanFail(error))
    }
  }

  function* onPostAppDynamicsAlert({payload:data}) {
    try{
      const response = yield call(postAppDynamicsAlertUrl, data)
      yield put(postAppDynamicsAlertsSuccess(response))
    } catch(error) {
      yield put(postAppDynamicsAlertFail(error))
    }
  }

  function* onGetAppDynamicsResourceDefaultThresholdById(data) {
    try{
      const response = yield call(getAppDynamicsResourceDefaultThresholdByIdUrl, data.payload)
      yield put(getAppDynamicsResourcesDefaultThresholdByIdSuccess(response))
    } catch(error) {
      yield put(getAppDynamicsResourcesDefaultThresholdByIdFail(error))
    } 
  }

  function* onPostAppDynamicsEnableDisableAlerts({payload: {data}}){
    try{
      const response = yield call(postAppDynamicsEnableDisableAlertsUrl, data)
      yield put(postAppDynamicsEnableDisableAlertsSuccess(response));
    } catch(error) {
      yield put(postAppDynamicsEnableDisableAlertsFail(error))
    }
  }

  function* onPostAppDynamicsCreateResourceAlerts({payload: {data}}){
    try{
      const response = yield call(postAppDynamicsCreateResourceAlertsUrl, data)
      yield put(postAppDynamicsCreateResourceAlertsSuccess(response));
    } catch(error) {
      yield put(postAppDynamicsCreateResourceAlertsFail(error))
    }
  }

  function* onPostAppDynamicsCreateDynamicAlert({payload: {data}}){
    try{
      const response = yield call(postAppDynamicsCreateDynamicAlertUrl, data)
      yield put(postAppDynamicsCreateDynamicAlertSuccess(response));
    } catch(error) {
      yield put(postAppDynamicsCreateDynamicAlertFail(error))
    }
  }

  function* onGetAppDynamicsAlerts({payload:monitored_resource_id}) {
    try{
      const response = yield call(getAppDynamicsAlertUrl, monitored_resource_id)
      yield put(getAppDynamicsAlertsSuccess(response));
    } catch(error) {
      yield put(getAppDynamicsAlertsFail(error))
    }
  }

  function* onGetAppDynamicsDynamicAlerts({payload:monitored_resource_id}) {
    try{
      const response = yield call(getAppDynamicsDynamicAlertsUrl, monitored_resource_id)
      yield put(getAppDynamicsDynamicAlertsSuccess(response))
    } catch(error) {
      yield put(getAppDynamicsDynamicAlertsFail(error));
    }
  }

  function* onGetAppDynamicsMissingDynamicAlerts(monitored_resource_id) {
    try{
      const response = yield call(getAppDynamicsMissingDynamicAlertsUrl, monitored_resource_id)
      yield put(getAppDynamicsMissingDynamicAlertsSuccess(response))
    } catch(error){
      yield put(getAppDynamicsMissingDynamicAlertsFail(error));
    }
  }

  function* onGetAppDynamicsDefaultThreshold(threshold_type) {
    try{
      const response = yield call(getAppDynamicsDefaultThresholdUrl, threshold_type)
      yield put(getAppDynamicsDefaultThresholdSuccess(response))
    } catch(error) {
      yield put(getAppDynamicsDefaultThresholdFail(error))
    }
  }

  function* onGetAppDynamicsThreshold() {
    try{
      const response = yield call(getAppDynamicsThresholdUrl)
      yield put(getAppDynamicsThresholdSuccess(response))
    } catch(error) {
      yield put(getAppDynamicsThresholdFail(error))
    }
  }

  function* onGetAppDynamicsResourceById({payload:data}) {
    try{
      const response = yield call(getAppDynamicsResourceByIDUrl,data);
      yield put(getAppDynamicsResourceByIdSuccess(response));
    } catch(error) {
      yield put(getAppDynamicsResourceByIdFail(error))
    }
  }

function* onGetADMissingAlertsByResourceID(monitored_resource_id) {
    try {
        const response = yield call(getAppDynamicsMissingAlertByResourceIdUrl, monitored_resource_id.payload);
        yield put(getMissingADAlertsByResourceIDSuccess(response));
    } catch (error) {
        yield put(getMissingADAlertsByResourceIDFail(error.message));
    }
}

function* onGetAppDynamicsAllBusinessTransactionsPage({payload:data}) {
    try{
        const response = yield call(getAppDynamicsAllBusinessTransactionAlertsUrl, data)
        yield put(getAppDynamicsAllBusinessTransactionsSuccess(response));
    } catch(error) {
        yield put(getAppDynamicsAllBusinessTransactionsFail(error))
    }
}

function* onGetAppDynamicsAllExternalServicesPage({payload:data}) {
    try{
        const response = yield call(getAppDynamicsAllExternalServicesURL, data)
        yield put(getAppDynamicsAllExternalServicesPageSuccess(response));
    } catch(error) {
        yield put(getAppDynamicsAllExternalServicesPageFail(error))
    }
}

function* onGetADNonKeyTransactionsByParentResource({payload:data}) {
    try {
        const response = yield call(getNonKeyTransactionsByParentResourceUrl, data)
        yield put(getADNonKeyTransactionsSuccess(response));
    } catch (error) {
        yield put(getADNonKeyTransactionsFail(error))
    }
}

function* onPostMarkNonKeyTransactionAsBusinessTransaction({payload:data}) {
    try {
        const response = yield call(postMarkNonKeyTransactionAsBusinessTransactionUrl, data)
        yield put(postMarkNonKeyTransactionAsBusinessTransactionSuccess(response));
    } catch (error) {
        yield put(postMarkNonKeyTransactionAsBusinessTransactionFail(error))
    }
}

  function* appDynamicsSaga(){
    yield takeEvery(GET_APP_DYNAMICS_RESOURCE_BY_ID, onGetAppDynamicsResourceById);
    yield takeEvery(POST_APP_DYNAMICS_ENABLE_DISABLE_ALERTS, onPostAppDynamicsEnableDisableAlerts);
    yield takeEvery(POST_APP_DYNAMICS_CREATE_RESOURCE_ALERTS, onPostAppDynamicsCreateResourceAlerts);
    yield takeEvery(GET_APP_DYNAMICS_ALERTS, onGetAppDynamicsAlerts);
    yield takeEvery(GET_APP_DYNAMICS_DEFAULT_THRESHOLD, onGetAppDynamicsDefaultThreshold);
    yield takeEvery(GET_APP_DYNAMICS_RESOURCE_DEFAULT_THRESHOLD_BY_ID, onGetAppDynamicsResourceDefaultThresholdById);
    yield takeEvery(POST_APP_DYNAMICS_ALERT, onPostAppDynamicsAlert);
    yield takeEvery(GET_APP_DYNAMICS_RESCAN, onGetAppDynamicsRescan);
    yield takeEvery(GET_APP_DYNAMICS_MISSING_ALERT_BY_RESOURCE_ID, onGetAppDynamicsMissingAlertByResourceId);
    yield takeEvery(POST_APP_DYNAMICS_SERVICE_MAPPING, onPostAppDynamicsServiceMapping);
    yield takeEvery(POST_APP_DYNAMICS_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostAppDynamicsResourceOpsgenieTeamMapping);
    yield takeEvery(POST_APP_DYNAMICS_RESOURCE_PAGERDUTY_SERVICE_MAPPING, onPostAppDynamicsResourcePagerdutyServiceMapping);
    yield takeEvery(GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_PAGE, onGetAppDynamicsAllResourceAlertsPage);
    yield takeEvery(GET_APP_DYNAMICS_ALL_RESOURCE_ALERTS_COUNT_PAGE, onGetAppDynamicsAllResourceAlertsCountPage);
    yield takeEvery(GET_APP_DYNAMICS_RESOURCES, onGetAppDynamicsResources);
    yield takeEvery(GET_ALL_ORG_APP_DYNAMICS_RESOURCE_TYPES, onGetAllOrgAppDynamicsResourceTypes);
    yield takeEvery(GET_RESCAN_STATUS_APP_DYNAMICS, onGetRescanStatusAppDynamics);
    yield takeEvery(POST_UPDATE_APP_DYNAMICS_THRESHOLD, onPostUpdateAppDynamicsThreshold);
    yield takeEvery(POST_ENABLE_DISABLE_APP_DYNAMICS_THRESHOLD, onPostEnableDisableAppDynamicsThreshold);
    yield takeEvery(GET_AD_MISSING_ALERTS_BY_RESOURCE_ID, onGetADMissingAlertsByResourceID);
    yield takeEvery(GET_APP_DYNAMICS_THRESHOLD, onGetAppDynamicsThreshold);
    yield takeEvery(GET_APP_DYNAMICS_ALL_EXTERNAL_SERVICES, onGetAppDynamicsAllExternalServicesPage);
    yield takeEvery(GET_APP_DYNAMICS_ALL_BUSINESS_TRANSACTIONS, onGetAppDynamicsAllBusinessTransactionsPage);
    yield takeEvery(GET_AD_NON_KEY_TRANSACTIONS, onGetADNonKeyTransactionsByParentResource);
    yield takeEvery(POST_MARK_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION, onPostMarkNonKeyTransactionAsBusinessTransaction);
  }

 export default appDynamicsSaga;